const orderCharged = "OrderCharged"; // Triggered when an order has been successfully processed for a one-time fee product or for the initial order of the subscription.
const orderRefunded = "OrderRefunded"; // Triggered when an order has been fully refunded.
const orderChargedBack = "OrderChargedBack"; // Triggered when we have received a chargeback for the order.

export const $orderIpnTypeName = {
  orderCharged,
  orderRefunded,
  orderChargedBack,
};

const subscriptionChargeSucceed = "SubscriptionChargeSucceed"; // Triggered when a recurring payment (order) has been successfully processed.
const subscriptionChargeFailed = "SubscriptionChargeFailed"; // Triggered when a recurring payment (order) has failed.
const subscriptionRenewed = "SubscriptionRenewed"; // Triggered when a subscription has been successfully renewed
const subscriptionFinished = "SubscriptionFinished"; // Triggered when a subscription has ended.
const subscriptionSuspended = "SubscriptionSuspended"; // 	Triggered when a subscription has been suspended by the customer, vendor, or our Support Team (as per the customer's or vendor's request).

export const $subscriptionIpnTypeNames = {
  subscriptionChargeSucceed,
  subscriptionChargeFailed,
  subscriptionRenewed,
  subscriptionFinished,
  subscriptionSuspended,
};
